import type {
  TwoBusinessRegistrationCreateRequestType,
  TwoBusinessRegistrationCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  apiV2AssertResponse,
  apiV2Request,
} from "../../../../../hooks/api/v2/apiV2Request";
import { useSellarCurrentBusiness } from "../../../../../hooks/useSellarCurrentBusiness.shared";
import { useFirebaseUser } from "../../../../../hooks/useFirebaseUser.shared";
import { ServerStateKeys } from "../../../../../hooks/api/v2/ServerStateKeys";

export const useCreateTwoBusinessRegistrationApplication = () => {
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: { data: TwoBusinessRegistrationCreateRequestType }) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `two/business-registration`,
        data: request.data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as TwoBusinessRegistrationCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.TwoCreateBusinessRegistrationApplication,
        ],
      });
    },
  });
};
